<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />
    <WidgetSlider />
    <ServiceSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ServiceSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ServiceSlider')"
    />
    <ReasonsSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ReasonsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ReasonsSlider')"
    />
    <UsefulTools
      :itemData="_.get(this.$store.state.current_content, 'secondary.usefull_tools.conf')"
      v-if="_.get(this.$store.state.current_content, 'secondary.usefull_tools.conf.enabled')==1"
      :firstLook="4"
      :ipadLook="2.5"
    />
    <ProductsSlider
      class="change-pad"
      v-if="_.get(this.$store.state.current_content, 'secondary.ProductsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ProductsSlider')"
    />
    <MoreWaysForBanking class="change-pad"/>
  </div>
</template>


<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import WidgetSlider from "@/components/WidgetSlider";
import ServiceSlider from "@/components/ServiceSlider";
import ReasonsSlider from "@/components/ReasonsSlider";
import UsefulTools from "@/components/UsefulTools";
import ProductsSlider from "@/components/ProductsSlider";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    WidgetSlider,
    ServiceSlider,
    ReasonsSlider,
    UsefulTools,
    ProductsSlider,
    MoreWaysForBanking,
  },

  data() {
    return {};
  },
  mounted() {
    // console.log(this.$store.state.current_content);
  },
  computed: {},
};
</script>



